"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var EmptyUser = function EmptyUser() {
  return _react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "89",
    height: "89",
    fill: "none",
    viewBox: "0 0 89 89"
  }, _react.default.createElement("path", {
    fill: "#242523",
    fillRule: "evenodd",
    d: "M44.699 44.118c12.183 0 22.059-9.876 22.059-22.059C66.758 9.876 56.882 0 44.698 0 32.517 0 22.64 9.876 22.64 22.059c0 12.183 9.876 22.06 22.059 22.06zM88.618 88.4H.42c.905-15.323 10.718-43.179 48.022-43.179 30.639 3.004 39.55 30.038 40.176 43.18z",
    clipRule: "evenodd"
  }));
};

var _default = EmptyUser;
exports.default = _default;